export const SET_APP_CONTENT = "SET_APP_CONTENT";
export const SET_CND_CONTENT = "SET_CND_CONTENT";
export const SAVE_LG_QUERY_PARAMS = "SAVE_LG_QUERY_PARAMS";